import classNames from 'classnames';
import React from 'react';
import base from '../../styles/base.less';

export interface ContentWrapperBreakoutProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const ContentWrapperBreakout = (props: ContentWrapperBreakoutProps) => {
  const { className, style, children } = props;
  const classnames = classNames(base.contentWrapperBreakout, className);
  return (
    <div className={classnames} style={style}>
      {children}
    </div>
  );
};
